var app = angular.module("leonardo");

var DeleteUnitTypeDialog = function($scope, UnitService, UnitTypeService, FormErrorsService) {
  $scope.unit_type = $scope.ngDialogData.unit_type;

  $scope.unit_types =  [];
  if (UnitTypeService.getCollection().length > 0) {
    var results = UnitTypeService.getCollection();
    var valid_results = [];
    angular.forEach(results, function(type) {
      if (type.id != $scope.unit_type.id) {
        valid_results.push(type);
      }
    });
    $scope.unit_types = valid_results;
  }
  else {
    UnitTypeService.getAll({essential:true}).then(function(data) {
      var response = data.results ? data.results : data;
      var valid_response = [];
      angular.forEach(response, function(type) {
        if (type.id != $scope.unit_type.id) {
          valid_response.push(type);
        }
      });
      $scope.unit_types = valid_response;
    });
  }
  $scope.new_unit_type = null;
  
  $scope.delete = function () {
    UnitTypeService.deleteUnitsType({unit_type: $scope.unit_type.id}).then(function() {
      UnitService.getAll({essential:true});
      $scope.confirm($scope.unit_type);
    }, function () {
      $scope.closeThisDialog();
    });
  };

  $scope.replace = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    UnitTypeService.deleteUnitsType({unit_type: $scope.unit_type.id, new_unit_type: $scope.new_unit_type}).then(function() {
      UnitService.getAll({essential:true});
      $scope.confirm($scope.unit_type);
    }, function () {
      $scope.closeThisDialog();
    });
  };

};

app.controller('DeleteUnitTypeDialog', ['$scope', 'UnitService', 'UnitTypeService', 'FormErrorsService', DeleteUnitTypeDialog]);
